// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"EBBBottomNav_bottomNav__FzVu8","navItem":"EBBBottomNav_navItem__UCubg","icon":"EBBBottomNav_icon__BvXNF","label":"EBBBottomNav_label__kcDLO"};